import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EympNoticesRoutingModule } from './eymp-notices-routing.module';
import { DatePickerModule, DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LayoutModule, StepperComponent } from "@progress/kendo-angular-layout";
import { GridModule, ExcelModule } from '@progress/kendo-angular-grid';
import { FloatingLabelModule } from '@progress/kendo-angular-label';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardDetailsComponent } from './dashboard-details/dashboard-details.component';

@NgModule({
  declarations: [
  
    DashboardComponent,
       DashboardDetailsComponent
  ],
  imports: [
    EympNoticesRoutingModule,
    CommonModule,
    DatePickerModule,
    FormsModule,
    GridModule,
    ExcelModule,
    TextBoxModule,
    FloatingLabelModule,
    ReactiveFormsModule,
    DialogsModule
  ]
})
export class EympNoticesModule { }
